import { render, staticRenderFns } from "./adddept.vue?vue&type=template&id=40689425"
import script from "./adddept.vue?vue&type=script&lang=js"
export * from "./adddept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports